import { useNavigate } from "react-router-dom";
import { Button, Typography } from "../common";
import { Trophy } from "lucide-react";

const CertificateNotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-primary rounded-full mb-4 shadow-lg">
        <Trophy className="w-8 h-8 text-white" />
      </div>
      <Typography variant="h1" weight="bold">
        404
      </Typography>
      <Typography variant="h2" weight="medium" className="mt-4">
        Certificate Not Found
      </Typography>
      <Typography variant="p" className="mt-2 text-center max-w-md">
        The certificate you're looking for doesn't exist or you don't have
        access to it.
      </Typography>
      <div className="flex flex-col sm:flex-row gap-3 mt-6">
        <Button
          onClick={() => navigate("/certificates")}
          variant="filled"
          size="large"
        >
          View All Certificates
        </Button>
        <Button onClick={() => navigate("/")} variant="outline" size="large">
          Go Home
        </Button>
      </div>
    </div>
  );
};

export default CertificateNotFound;
